import { formatDataTest } from '@/common/dataTest/DataTest';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { StringUtils } from '@/common/utils/StringUtils';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardHeader,
  Divider,
  Menu,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useNotif } from './NotifContext';

export const NotifMenu = ({
  anchorEl,
  open,
  onClose,
}) => {

  const [notifs, setNotifs] = useState([]);

  const rsrc = useRsrc();
  const { principal } = usePrincipal();
  const { navigateTo } = useNavState();
  const { notifCount } = useNotif();

  useEffect(() => {
    const rowsReq = {
      replaceParams: { username: principal.username }
    }
    rsrc.rows('skdr', 'NOTIF_MSGS', rowsReq).then(notifs => {
      setNotifs(notifs);
    })
  }, [notifCount, open])

  const ack = (notif) => {
    rsrc.save('skdr', 'NOTIF', [{ id: notif.id, ack: true }])
  }

  const ackAll = () => {
    rsrc.store('skdr', 'NOTIF_ACK_ALL_STORE_PLUGIN', {})
  }

  const downloadNotif = (notif) => {
    const exportId = notif.data;
    rsrc.download(notif.module, exportId);
  }

  const toApprObj = (notif) => {
    onClose();
    const data = JSON.parse(notif.data).map;

    const route = data.module.toLowerCase() + '/' + StringUtils.toKebabConvention(data.entity);
    let navState = {
      entityId: data.entityId,
      mode: Mode.DETAIL
    }

    navigateTo(route, navState);
  }

  const renderMenuContent = () => {
    // No Notifications Scenario
    if (notifs.length === 0) {
      return (
        <Box sx={{ p: 2 }}>
          <Typography variant="body2" color="text.secondary">
            No notifications
          </Typography>
        </Box>
      )
    }

    // Render Content for Notifications
    return (
      <Box>
        <Box>
          <Box sx={{ p: 1 }}>
            <Button variant="contained" color="primary" onClick={ackAll} fullWidth>
              Acknowledge All
            </Button>
          </Box>
          <Divider />
        </Box>
        <Box sx={{ maxHeight: 500, overflowY: 'auto' }}>
          {notifs.map((notif, index) => (
            <Box key={index} sx={{ p: 1 }}>
              <Card variant="outlined">
                <CardHeader
                data-test-id={`notif-message-${index}`}
                  title={notif.msg}
                  subheader={StringUtils.toLocalInstant(notif.verStartInstant)}
                />
                <CardActions sx={{ justifyContent: 'flex-end' }}>
                  {notif.eventType === 'FINISH_SUCCESS' && notif.jobCat === 'EXPORT' &&
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => downloadNotif(notif)}
                    >
                      Download
                    </Button>
                  }
                  {notif.eventType === 'APPR_REQ' &&
                    <Button
                      variant="contained"
                      size="small"
                      data-test-id={formatDataTest('notif-menu-item', index, 'details')}
                      onClick={() => toApprObj(notif)}
                    >
                      Details
                    </Button>
                  }
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => ack(notif)}
                  >
                    Acknowledge
                  </Button>
                </CardActions>
              </Card>
            </Box>
          ))}
        </Box>
      </Box>
    )
  }

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
      transformOrigin={{ vertical: 'center', horizontal: 'left' }}
      slotProps={{ paper: { sx: { width: 350 } } }}
    >
      {renderMenuContent()}
    </Menu>
  );
};
